import React from "react";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { AccessTime } from "@mui/icons-material";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);

const containerStyle = {
  position: "relative",
  width: "100%",
  height: "350px",
};

export const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",
    },
    title: {
      display: true,
      text: "6-month projection",
    },
  },
};

const labels = ["January", "February", "March", "April", "May", "June", "July"];

export const defaultData = {
  labels,
  datasets: [
    {
      type: "line",
      label: "Historical min",
      borderColor: "rgb(255, 99, 132)",
      borderWidth: 2,
      backgroundColor: "rgb(255, 99, 132)",
      data: [8, 8, 8, 8, 8, 8, 8],
      fill: false,
    },
    {
      type: "line",
      label: "Historical max",
      borderColor: "rgb(75, 192, 192)",
      borderWidth: 2,
      backgroundColor: "rgb(75, 192, 192)",
      data: [84, 84, 84, 84, 84, 84, 84],
      fill: false,
    },
    {
      type: "bar",
      label: "Dataset",
      backgroundColor: "rgb(53, 162, 235)",
      data: [60, 55, 60, 63, 68, 70, 75],
    },
  ],
};

const MultitypeChartComponent = ({
  data,
  options = defaultOptions,
  chartType = "line",
  plugins,
  isLoading,
  emptyModel,
  t,
}) => {
  return (
    <div style={containerStyle}>
      {isLoading ? (
        <Box
          display="flex"
          width="100%"
          height="100%"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress />
        </Box>
      ) : emptyModel ? (
        <Box
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          gap={2}
        >
          <AccessTime />
          <Stack
            direction="column"
            sx={{
              alignItems: "center",
              textAlign: "center",
              "& > *": { marginBottom: "0.2rem" }, // Riduce lo spazio tra gli elementi
            }}
          >
            {t("real-time-page.no_models_data_message")
              .split(".")
              .filter((sentence) => sentence.trim() !== "") // Filtra le stringhe vuote
              .map((sentence, index, array) => (
                <Typography
                  key={index}
                  sx={{ lineHeight: 1.2 }} // Riduce l'altezza della linea
                >
                  {sentence}
                  {index < array.length - 1 ? "." : ""}
                </Typography>
              ))}
          </Stack>
        </Box>
      ) : (
        <Chart
          options={options}
          type={chartType}
          data={data}
          plugins={plugins}
        />
      )}
    </div>
  );
};

export default MultitypeChartComponent;
